export default function Router($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider
        .when("/app/deployments", "/app/deployments/");

    $stateProvider
        .state({
            name: "deployments",
            url: "/app/deployments",
            template: "<deployments></deployments>",
            resolve: {
                $title: () => "Deployments | UpReach Cloud"
            }
        })
        .state({
            name: "deployments.list",
            url: "/?:code",
            template: "<deployment-list></deployment-list>",
            resolve: {
                $title: () => "Deployments | UpReach Cloud"
            }
        })
        .state({
            name: "deployments.update",
            url: "/:cid/?:isNew/?:company/:?code",
            template: "<deployment-update></deployment-update>",
            resolve: {
                $title: () => "Deployment Update | UpReach Cloud"
            }
        })
        .state({
            name: "deployments.setting",
            url: "/setting/:cid",
            template: "<deployment-setting></deployment-setting>",
            resolve: {
                $title: () => "Deployment Setting | UpReach Cloud"
            }
        });
}


// WEBPACK FOOTER //
// ./sources/components/deployments/deployments-router.js